import { useCallback } from "react";

import useClient from "hooks/useClient";

const useAcceptServiceEstimate = (): {
  acceptEstimate: (
    optionId: string,
    serviceId: string,
    estimateId: string,
    remarks: string,
    agreed: boolean
  ) => Promise<number>;
} => {
  const { client } = useClient();

  const acceptEstimate = useCallback(
    async (optionId: string, serviceId: string, estimateId: string, remarks: string, agreed: boolean) => {
      const { status } = await client({
        method: "put",
        url: `/option/${optionId}/request-service/${serviceId}/estimate/${estimateId}/accept-estimate`,
        data: { remarks, agreed },
      });
      return status;
    },
    [client]
  );

  return { acceptEstimate };
};

export default useAcceptServiceEstimate;
